module.exports = __webpack_public_path__ + "static/image_17-ecb5e403b1b8e317f4676c9d4f1544a8.jpg";